import { translate, type Translation } from "./lang.ts";
import { towerEn } from "./logictower.en.ts";

/**
 * Tháp Bi Lật copy (Logic Tower). Same house style as vi.ts:
 * warm and plain, no dashes, dots, slashes, symbols or parentheses.
 * English twin in `logictower.en.ts`.
 */
const source = {
  drops: (n: number) => `Đã thả ${n}`,
  hintCost: "Xài gợi ý thì màn này tối đa 2 sao thôi đó. Vẫn xài hông?",
  resultDrops: (n: number, best: number) =>
    n <= best ? `Bạn thả ${n} lượt, gọn y như lời giải đẹp nhất!` : `Bạn thả ${n} lượt, lời giải gọn nhất là ${best} lượt.`,
  resultRule: (three: number, two: number) => `Ba sao khi thả không quá ${three} lượt, hai sao khi không quá ${two} lượt.`,
  resultHint: "Có xài gợi ý nên tối đa 2 sao nha.",
};

export type TowerStrings = Translation<typeof source>;

export const towerVi: TowerStrings = translate(source, towerEn);
